const TechnicalTeamData = [
  {
    name: "JP NetworkBD",
    img: "https://i.ibb.co/s9J1Hpx/60111.webp",
    phone: "01757155854",
    designation: "Assistant Technician",
    fb: "",
  },
  {
    name: "JP NetworkBD",
    img: "https://i.ibb.co/s9J1Hpx/60111.webp",
    phone: "01600086062",
    designation: "Assistant Technician",
    fb: "",
  },
  {
    name: "JP NetworkBD",
    img: "https://i.ibb.co/s9J1Hpx/60111.webp",
    phone: "01618950343",
    designation: "Technician",
    fb: "",
  },
  {
    name: "JP NetworkBD",
    img: "https://i.ibb.co/s9J1Hpx/60111.webp",
    phone: "01812441900",
    designation: "Technician",
    fb: "",
  },
];

export default TechnicalTeamData;
